if (!customElements.get('latest-articles')) {
  class LatestArticles extends HTMLElement {
    constructor() {
      super();
      this.itemsContent = this.querySelector('.items-wrapper');
      this.searchUrl = this.dataset.searchUrl || (window.routes?.search_url || '/search') + '?view=articles_json&type=article&q=*';
      this.layout = this.dataset.layout || 'grid';
      this.itemsLimit = parseInt(this.dataset.itemsLimit, 10) || 50;
      this.noArticlesMsg = "No articles found.";
      this.unableMsg = "Unable to load articles.";
      this.showArticles();
    }

    showArticles() {
      if (!this.itemsContent) return;
      fetch(this.searchUrl)
        .then(res => res.json())
        .then(data => {
          const articles = data.articles || [];
          if (articles.length === 0) {
            this.itemsContent.innerHTML = '<p class="text-center">No articles found.</p>';
            this.style.display = '';
            return;
          }
          const path = (u) => (u || '').split('?')[0];
          const toShow = articles.slice(0, this.itemsLimit);
          const urls = toShow.map(a => window.location.origin + path(a.url) + '?sections=article_card_ajax');
          $s.getDataFromUrls(urls).then(fetched => {
            let html = '';
            toShow.forEach((article) => {
              const articleUrl = window.location.origin + path(article.url) + '?sections=article_card_ajax';
              const raw = fetched[articleUrl];
              if (raw) {
                try {
                  const parsed = typeof raw === 'object' ? raw : (typeof raw === 'string' && raw.trim().startsWith('{') ? JSON.parse(raw) : null);
                  if (!parsed) return;
                  const sectionHtml = parsed.article_card_ajax || Object.values(parsed).find(v => v && typeof v === 'string' && v.includes('article-card'));
                  if (sectionHtml) {
                    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
                    const card = doc.querySelector('.article-card-ajax.grid-item') || doc.querySelector('.article-card');
                    if (card) {
                      card.classList.add('article-item');
                      if (this.layout === 'carousel') {
                        html += '<div class="keen-slider-slide">' + card.outerHTML + '</div>';
                      } else {
                        html += card.outerHTML;
                      }
                    }
                  }
                } catch (e) { console.error(e); }
              }
            });
            const btn = this.itemsContent.querySelector('.btn-expand');
            if (btn) {
              btn.insertAdjacentHTML('beforebegin', html || `<p class="text-center">${this.noArticlesMsg}</p>`);
            } else {
              this.itemsContent.innerHTML = html || `<p class="text-center">${this.noArticlesMsg}</p>`;
            }
            this.itemsContent.querySelectorAll('.article-card').forEach(card => {
              if (this.dataset.cardsColorScheme) card.classList.add('scheme', ...this.dataset.cardsColorScheme.split(' '));
              card.classList.toggle('same-scheme-true', this.dataset.cardsColorScheme === this.dataset.contentColorScheme);
              card.classList.toggle('same-scheme-false', this.dataset.cardsColorScheme !== this.dataset.contentColorScheme);
            });
            if (this.layout === 'carousel') {
              const carousel = this.querySelector('component-carousel');
              if (carousel && typeof carousel.initSlider === 'function') {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => carousel.initSlider());
                });
              }
            } else {
              const btn = this.querySelector('.btn-expand');
              if (btn) {
                const first = this.itemsContent.querySelector('.grid-item');
                if (first) this.itemsContent.style.setProperty('--gradient-height', first.offsetHeight + 'px');
              }
              if (this.dataset.matchTitleHeight) {
                const titles = this.itemsContent.querySelectorAll('.common-card .title');
                if (titles.length) $s.matchHeight(titles);
              }
            }
            this.style.display = '';
          });
        })
        .catch(e => {
          console.error(e);
          this.itemsContent.innerHTML = `<p class="text-center">${this.unableMsg}</p>`;
          this.style.display = '';
        });
    }
  }
  customElements.define('latest-articles', LatestArticles);
}
